import { useTranslation } from 'react-i18next';

import type { ColorTheme } from '~/api/user/types';

import { useUpdateAppSettings, useUser } from '~/api/user';
import { colorThemes } from '~/api/user/constants';
import { brandColorThemes } from '~/styles/themes.css';
import { clsx } from '~/styles/utils';
import { toast } from '~/utils/toast';

import { halfStyles, listStyle, rotatedStyle, swatchStyle } from './ThemePicker.css';

export const ThemePicker = () => {
  const { data: user } = useUser();
  const mutation = useUpdateAppSettings();

  const { t } = useTranslation(['common', 'settings']);

  const saveTheme = (theme: ColorTheme) => {
    mutation.mutate(
      { appSettings: { theme: { ...user.appSettings.theme, invoiceColor: theme } } },
      { onError: () => toast.danger({ description: t('common:error') }) },
    );
  };

  return (
    <div className={listStyle}>
      {colorThemes.map((colorTheme) => (
        <button
          aria-label={t(`common:colorPicker.options.${colorTheme}`)}
          aria-pressed={user.appSettings.theme?.invoiceColor === colorTheme}
          className={clsx(brandColorThemes[colorTheme], swatchStyle)}
          key={colorTheme}
          onClick={() => saveTheme(colorTheme)}
          type="button"
        >
          <div className={rotatedStyle}>
            <div className={halfStyles.top} />
            <div className={halfStyles.bottom} />
          </div>
        </button>
      ))}
    </div>
  );
};
